// HomePage.js
import React, { useState, useEffect } from "react";
import PreRegisterModal from "./PreRegisterModal";

function HomePage() {
  const words = ["Restaurant", "Home", "Cafe", "Bar"];
  const [currentWord, setCurrentWord] = useState(words[0]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    let wordIndex = 0;
    const intervalId = setInterval(() => {
      wordIndex = (wordIndex + 1) % words.length;
      setCurrentWord(words[wordIndex]);
    }, 2000);

    return () => clearInterval(intervalId);
  }, []);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="bg-white mt-2 flex flex-col items-center justify-center text-center sm:px-2 overflow-x-hidden w-full">
      <h1 className="text-2xl sm:text-4xl lg:text-6xl font-bold text-gray-900 mb-5">
        Conveys mingling <br /> socializing in a{" "}
        <span className="text-red-500">{currentWord}</span>
      </h1>
      <p className="text-sm sm:text-lg md:text-2xl text-gray-700 mb-4">
        Connect with vibrant places and people. Sign up today and start your
        journey to unforgettable experiences.
      </p>
      <button
        onClick={handleOpenModal}
        className="bg-red-500 text-white font-bold py-2 px-4 rounded-full w-64 h-12"
      >
        Sign Up
      </button>

      <PreRegisterModal isModalOpen={isModalOpen} onClose={handleCloseModal} />
    </div>
  );
}

export default HomePage;
